import type { ComboboxStore } from '@mantine/core';

/**
 * Highlights option `index` one frame after a `keepMounted={false}` dropdown opens: its options mount with
 * the dropdown, so they exist only from the next frame. A keyboard navigation that lands inside that frame
 * has already chosen a highlight; it wins, and the deferred call does nothing.
 */
export function selectOptionOnceMounted(combobox: ComboboxStore, index: number) {
  requestAnimationFrame(() => {
    if (combobox.getSelectedOptionIndex() === -1) {
      combobox.selectOption(index);
    }
  });
}
